import { ThemeConfig } from 'antd';
import { variables } from './common';

// Define the theme configuration for Ant Design
export const theme: ThemeConfig = {
  token: {
    colorPrimary: variables.colors.purple,
    // You can customize other theme tokens here if needed
    borderRadius: 6,
  },
};
